"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductGridItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
/**
 * Render ProductGridItem
 *
 * @param {Object} props React props
 * @param {string} [props.id] Product Grid Item id
 * @param {string} [props._name] Product Grid Item tracking name
 * @param {string} [props.text] ProductGridItem Label
 * @param {string} [props.link] ProductGridItem Link url
 * @param {bool} [props.link] openInNewWindow - set target to _blank if true
 * @param {Object} [props.style] required for Linaria Styling Overrides
 * @param {string} [props.className] required for Linaria Styling Overrides
 * @returns {React.ReactElement} ProductGridItem component
 * @public
 */
function ProductGridItem({
  _name,
  id,
  text,
  link,
  hoverEffect = false,
  openInNewWindow = false,
  style,
  className
}) {
  const target = openInNewWindow ? {
    target: '_blank'
  } : {};
  return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    id: `id-${id}`,
    "data-cy": "item",
    className: className,
    style: style,
    href: link,
    "data-hover-active": hoverEffect
  }, target, _patternLibraryUtils.tracking.create(_name, true, true)), /*#__PURE__*/_react.default.createElement("span", null, text), hoverEffect && /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "link-arrow"
  }));
}
ProductGridItem.propTypes = {
  _name: _propTypes.default.string.isRequired,
  id: _propTypes.default.string.isRequired,
  text: _propTypes.default.string.isRequired,
  link: _propTypes.default.string.isRequired,
  hoverEffect: _propTypes.default.bool,
  openInNewWindow: _propTypes.default.bool,
  style: _propTypes.default.object,
  className: _propTypes.default.string
};